import { render, staticRenderFns } from "./DetailedRepaletizajeProcess.vue?vue&type=template&id=575416b7"
import script from "./DetailedRepaletizajeProcess.vue?vue&type=script&lang=js"
export * from "./DetailedRepaletizajeProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports